import React from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import moment from 'moment';
import { TWSessionView } from '../../../../src/components/SessionLandingPage/TWSessionView';
import { truncate, removeHTMLTags } from '../../../../src/utils/helpers';
import TWServiceProfileLayout from '../../../../src/components/TWServiceProfileLayout/TWServiceProfileLayout.container';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;

var SessionView = function SessionView(_ref) {
  var session = _ref.session,
      service = _ref.service,
      provider = _ref.provider,
      schedule = _ref.schedule;
  if (!session) return /*#__PURE__*/_jsx("div", {
    className: "m-6",
    children: "Sorry, we could not find that session."
  });
  if (service) session.providerService = service;
  var sessionDescription = truncate(removeHTMLTags(session.description), 200);
  var sessionUrl = "https://subkit.com/".concat(provider.slug, "/sessions/").concat(session.slug);
  var profilePath = "/".concat(provider.slug);
  var metaTitleText = "".concat(session.name, " - ").concat(moment(session.startsAt).format('dddd, MMMM D'), " - ").concat(service.name, " by ").concat(provider.name);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: metaTitleText
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: sessionDescription
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:site_name",
        content: "Subkit"
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:title",
        content: metaTitleText
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:description",
        content: sessionDescription
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:url",
        content: sessionUrl
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:image",
        content: service.bgImageUrl
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:card",
        content: "summary_large_image"
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:title",
        content: "".concat(session.name, " by ").concat(service.name)
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:description",
        content: sessionDescription
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:image:alt",
        content: "".concat(session.name, " - ").concat(service.name, " by ").concat(provider.name)
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:url",
        content: sessionUrl
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:image",
        content: service.bgImageUrl
      })]
    }), /*#__PURE__*/_jsx(TWServiceProfileLayout, {
      children: /*#__PURE__*/_jsx(TWSessionView, {
        session: session,
        schedule: schedule,
        profilePath: profilePath
      })
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.auth.users.current
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionView);